// extracted by mini-css-extract-plugin
module.exports = {"possibleAnswers":"PossibleAnswers_possibleAnswers__3k8IQ","form_radio_btn":"PossibleAnswers_form_radio_btn___hi_G"};